import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../styles/app/Footer.css";

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section">
      <div>
        {t("footer.copyright", { year: currentYear })}
      </div>
      <div>
        <Link to="/terms" className="terms-link">
          {t("footer.terms")}
        </Link>
        {" | "}
        <Link to="/acceptable-use-policy" className="terms-link">
          {t("footer.acceptableUse")}
        </Link>
        {" | "}
        <Link to="/cookies-policy" className="terms-link">
          {t("footer.cookies")}
        </Link>
        {" | "}
        <Link to="/disclaimer" className="terms-link">
          {t("footer.disclaimer")}
        </Link>
        {" | "}
        <Link to="/privacy-policy" className="terms-link">
          {t("footer.privacy")}
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
